import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { FeatureURI, type AdItem } from '@sbt-web/network/types';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
export const useLiraLazyOverlayGalleryForPro = t0 => {
  const $ = _c(10);
  const {
    ad,
    isMobile
  } = t0;
  let t1;
  if ($[0] !== ad?.advertiser?.type || $[1] !== ad?.features || $[2] !== ad?.images?.length || $[3] !== isMobile) {
    t1 = () => {
      let slots = [];
      if (isMobile) {
        slots.push(LiraContainerIds.adView.anchorGallery);
      }
      if (!ad?.features?.[FeatureURI.ItemShippingCostTuttoSubito] && ad?.advertiser?.type === 1 && ad?.images?.length > 0) {
        if (isMobile) {
          slots.push(LiraContainerIds.adView.imageIntoGalleryForProMsite);
        } else {
          slots = [LiraContainerIds.adView.sponsorGallery, LiraContainerIds.adView.imageIntoGalleryForPro];
        }
      }
      if (slots.length > 0) {
        window.liraSDKQueue?.push(() => {
          window.liraSdk?.fetchLazyLoadAd(slots);
        });
      }
    };
    $[0] = ad?.advertiser?.type;
    $[1] = ad?.features;
    $[2] = ad?.images?.length;
    $[3] = isMobile;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = ad?.advertiser?.type;
  const t3 = ad?.features;
  const t4 = ad?.images?.length;
  let t5;
  if ($[5] !== isMobile || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = [t2, t3, t4, isMobile];
    $[5] = isMobile;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t1, t5);
};